module.exports = __webpack_public_path__ + "img/home_tab_material_sel.fc015487.png";